import { render } from "./contact-us.vue?vue&type=template&id=7c07220b&scoped=true"
import script from "./contact-us.vue?vue&type=script&lang=js"
export * from "./contact-us.vue?vue&type=script&lang=js"

import "./contact-us.vue?vue&type=style&index=0&id=7c07220b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c07220b"]])

export default __exports__